import { HttpHelpService } from '../../src/app/Data/service/http-help.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { extractKeys } from './helpers';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor( private router: Router , private service: HttpHelpService) {
  
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const path = route.url[0]?.path;
    const parentPath = route.parent?.routeConfig?.path;
    const isAdminNotificationsRoute = parentPath === 'admin' && path === 'notifications';
    if (!path) {
      this.router.navigate(['/login']);
      return false;
    }
    const userType = localStorage.getItem('userType_en');
    const privilege = localStorage.getItem('allPrivilige');
    const privilegeArray = privilege ? JSON.parse(privilege) : [];
    const children = privilegeArray?.children ?? [];
    const keys = extractKeys(children) ?? [];
    const isAdminUser = (userType || '').toLowerCase() === 'admin';
    // Allow specific admin-only screens even if menu cache doesn't have them yet
    if (
      (path === 'admin-expense-quota' ||
        path === 'admin-push-notifications' ||
        isAdminNotificationsRoute ||
        path === 'admin-merchant-subscriptions' ||
        path === 'admin-custom-payments' ||
        path === 'expense-plans' ||
        path === 'admin-app-version' ||
        path === 'tasks') &&
      isAdminUser
    ) {
      return true;
    }
    // If user can access plans screen, allow nested admin plan tools
    if ((path === 'admin-merchant-subscriptions' || path === 'admin-custom-payments') && keys.includes('plans-info')) {
      return true;
    }
    if (keys.includes(path)) {
      return true;
    }
    /* Nested admin routes: privilege_key is e.g. admin/notifications → path segment notifications */
    if (
      parentPath === 'admin' &&
      path &&
      keys.includes(`${parentPath}/${path}`)
    ) {
      return true;
    }
    this.router.navigate(['/login']);
    return false;
  }
  
}
